<form #domainGroupsRules="ngForm" id="domainGroupsRules">
    <div class="row">
        <div class="col-md-36">
            <button type="button" class="btn btn-border-radius btn-secondary" (click)="importRules()" *ngIf="isSudo">
                <span class="fas fa-file-import" aria-hidden="true"></span>
                <span translate>Import rules from CSV</span>
            </button>
        </div>

        <div class="col-md-12 col-48 text-right">
            <table-search [model]="search"
                          theme="grey"
                          class="block"
                          (getPage)="onSearch($event)">
            </table-search>
        </div>
    </div>
    <hr/>
    <mon-spinner [loading]="loadingLabels">
        <div *ngFor="let rule of (domainGroup?.rules | searchNative:'text':search | slice:(page-1) * pageSize:page * pageSize); let i = index">
            <form-domain-groups-match-rule
                [rule]="rule"
                (onConfirmRemove)="onConfirmRemove(rule)"
                [labels]="labels"
                [key]="i">
            </form-domain-groups-match-rule>
        </div>
    </mon-spinner>
    <div class="row">
        <div class="col-48">
            <button
                ngbTooltip="{{ 'Add another rule' | translate }}"
                [triggers]="'focus hover'"
                [placement]="'top'"
                [container]="'body'"
                type="button"
                class="btn btn-border-radius btn-secondary"
                (click)="addRule()">
                <span class="fas fa-plus"></span>
            </button>
        </div>
    </div>
    <div class="row">
        <div class="col-48 text-right">
            <ngb-pagination
                [disabled]="(domainGroup?.rules | searchNative:'text':search)?.length <= pageSize"
                [collectionSize]="(domainGroup?.rules | searchNative:'text':search)?.length"
                [(page)]="page"
                [maxSize]="pageSize"
                size="sm"
                [boundaryLinks]="false">
            </ngb-pagination>
        </div>
    </div>
</form>
